export enum ePayee {
  DueToSeller = 'Due to Seller',
  DueToBuyer = 'Due to Buyer',
  DueToBorrower = 'Due to Borrower',
  DueToCustomer = 'Net proceeds to customer',
  DueToUnison = 'Net fees to Unison',
}
export interface IDueTo {
  payee: ePayee;
  amount: number;
  isHidden: boolean;
}
